'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { interpolate } from '../utils/i18n';

const ValidI18nMessage = props => {
  const {
    message,
    options,
    defaultValue = '',
    messageComponent: MessageComponent = FormattedMessage
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["message", "options", "defaultValue", "messageComponent"]);

  if (!isValidI18nKey(message)) {
    return /*#__PURE__*/_jsx(SanitizedText, {
      body: interpolate(defaultValue, options),
      WrapperComponent: "span"
    });
  }

  return /*#__PURE__*/_jsx(MessageComponent, Object.assign({
    message: message,
    options: options
  }, rest));
};

ValidI18nMessage.propTypes = {
  defaultValue: PropTypes.string,
  message: PropTypes.string.isRequired,
  messageComponent: PropTypes.elementType,
  options: PropTypes.object
};
export default ValidI18nMessage;